/**
 * Rastermasse des Grundkalenders. Nur das Tagesraster scrollt horizontal; die Apartmentspalte
 * bleibt verankert.
 */
export const APARTMENT_COLUMN = 250;
export const APARTMENT_COLUMN_MOBILE = 116;
// Schmal genug, dass zwei Wochen auf einen breiten Bildschirm passen; Preis mit Schloss passt.
export const DAY_COLUMN_MIN = 64;
export const DAY_COLUMN_MIN_MOBILE = 88;
export const ROW_HEIGHT = 64;
/** Die gewaehlte Zeile waechst, damit die Zeitraum-Marke ueber dem Wert Platz hat. */
export const ROW_HEIGHT_SELECTED = 80;

export function gridColumns(sidebar: number, dayCount: number, dayMin: number): string {
  // Fest statt anteilig: als Anteil blaehte ein langer Status der Apartmentspalte ueber das
  // gemeinsame Mass jede Tagesspalte mit auf — dann passten nur noch vier Tage ins Bild.
  return `${sidebar}px repeat(${dayCount}, minmax(${dayMin}px, 1fr))`;
}
